import { render, staticRenderFns } from "./PConfetti.vue?vue&type=template&id=518c6844&"
import script from "./PConfetti.vue?vue&type=script&lang=js&"
export * from "./PConfetti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports